import { Box, Paper, Typography } from '@mui/material'

function HudBanner({ countyName, hiddenCount = 0, position = 'top-right', anchored = false }) {
  const posStyle = position === 'top-left'
    ? { top: 80, left: 16 }
    : position === 'top-center'
    ? { top: 80, left: '50%', transform: 'translateX(-50%)' }
    : { top: 80, right: 16 } // top-right default

  const content = (
    <Paper elevation={4} sx={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center', gap: 1.25, bgcolor: '#7454A5', color: 'white', borderRadius: 2, pl: 2, pr: 1.5, py: 0.75, boxShadow: '0 6px 16px rgba(116, 84, 165, 0.35)', border: '2px solid #5e4292', width: 'fit-content', textAlign: 'center' }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 800, letterSpacing: 0.3, whiteSpace: 'nowrap', textAlign: 'center' }}>
        {countyName || 'Select Region'}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
          <Box sx={{ bgcolor: 'white', color: '#7454A5', px: 1.25, py: 0.25, borderRadius: 9999, fontWeight: 800, fontSize: '0.85rem', minWidth: 28, textAlign: 'center', border: '2px solid #5e4292' }}>
            {hiddenCount}
          </Box>
        </Box>
      </Box>
    </Paper>
  )

  if (anchored) {
    return content
  }

  return (
    <Box sx={{ position: 'fixed', zIndex: 1400, ...posStyle }}>
      {content}
    </Box>
  )
}

export default HudBanner


